'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _reactJplayerUtils = require('react-jplayer-utils');
var _recompose = require('recompose');
var _actions = require('../../actions/actions');
var _remove = require('./remove');
var _remove2 = _interopRequireDefault(_remove);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var handlers = {
  remove: function remove(props) {
    return function () {
      return props.remove(props.id, props.index);
    };
  }
};
exports.default = (0, _recompose.compose)((0, _reactJplayerUtils.connectWithIndex)(null, {
  remove: _actions.remove
}), (0, _recompose.withHandlers)(handlers))(_remove2.default);